import { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { ToastProvider } from "./components/base/Toast";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./services/queryClient";
import Spinner from "./components/base/Spinner";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            <Suspense
              fallback={
                <div className="flex min-h-screen items-center justify-center">
                  <Spinner size="lg" />
                </div>
              }
            >
              <AppRoutes />
            </Suspense>
          </BrowserRouter>
        </ToastProvider>
      </QueryClientProvider>
    </I18nextProvider>
  );
}

export default App;
